module.exports = __webpack_public_path__ + "media/icons/Group@2x-ee12f613.png";